/**
 * @fileoverview Helpers to build organization invite links.
 * @module features/orgs/utils/inviteLinks
 */

import { type OrgId } from '../schemas/orgSchemas'

/**
 * Build a canonical invite link of the form `/accept-invite/:orgId?token=...`.
 * Uses `VITE_PUBLIC_URL` when available; falls back to `window.location.origin` in browser.
 *
 * @param orgId Organization identifier
 * @param token UUID invite token
 * @returns Absolute URL string suitable for emails or copy/share
 */
export function buildInviteLink(orgId: OrgId, token: string): string {
  const base =
    (import.meta.env?.VITE_PUBLIC_URL as string) ||
    (typeof window !== 'undefined' ? window.location.origin : '')
  const orgIdStr = orgId as unknown as string
  const params = new URLSearchParams({ token })
  return `${base}/accept-invite/${orgIdStr}?${params.toString()}`
}
